/**
 * 세금계산서 발행 / 거래처 입금 영수증 (구 public/js/m-diary-1.js 이관)
 *
 * 일지 상세의 세금계산서·거래처 입금 팝업에서 거래처 조회·선택·발행/입금 저장을 담당.
 * 저장 엔드포인트는 레거시 _sky_m_05_001_scr_get_html.php (jobtype 분기) — 추후 RESTful 별건.
 *
 * 마크업(render)·동작·생명주기를 모두 이 모듈이 갖는다. BS target 으로 열린다.
 *   $j.F.Diary.TaxBill.open(mode, ordernum, tarDiv, carPrice)
 * 진입점은 카드의 인라인 onclick="setBillStats(...)" (OrderDetailViewService 가 찍는다) →
 * Diary/Main.js 의 setBillStats 브리지가 이 open() 을 부른다.
 *
 * [공유 전역] ontractListOpenTab / coBizSelMode(거래처목록 탭 상태), billsetDiv(카드의 표시 영역),
 * LoginNo 는 여전히 레거시와 공유 → window 로 접근. (diary-js-migration.md §3)
 */
import Util from '../../Common/Util';
export default class TaxBill {
    constructor() {
        this.dateTarget = "";
        this.coBoxCalTar = null;
        this.otherCoDocs = null;
    }



    /**
     * 시트 열기.
     *
     * @param mode      'soo_bill_issued'(계산서) | 'bal_bill_issued'(거래처)
     * @param ordernum  오더번호
     * @param tarDiv    카드의 표시 영역 — 저장 후 라벨을 갈아끼운다
     * @param carPrice  장비대금 (금액칸 기본값 = 대금 + 부가세 10%)
     */
    open(mode, ordernum, tarDiv, carPrice) {
        $j.Ui.BS.open({
            target: '$j.F.Diary.TaxBill',
            fixedHeight: true,
            data: {
                mode,
                ordernum,
                tarDiv,
                carPrice: parseInt(carPrice, 10) || 0,
                workYear:  tarDiv ? tarDiv.getAttribute('date_y') : '',
                workMonth: tarDiv ? tarDiv.getAttribute('date_m') : '',
            },
        });
        $j.Ui.BS.setTitle(mode === 'bal_bill_issued' ? '거래처 계산서·입금' : '계산서·입금');
    }

    init() {
        this.$el = $(`#${this.id}`);
        this.$el.html(`<div class="taxbill__loading">${$j.Common.Util.spinnerHtml('jb-spin--fade')}</div>`);
        this.otherCoDocs = null;
        this.initHandler();
        this.load();
    }

    destroy() {
        this.$el?.off();
    }

    /** 인라인 onclick 대신 위임 — 마크업이 이 모듈 소유다. */
    initHandler() {
        this.$el
            .on('change', '[data-act="issue"]', (e) => this.billPopSet($(e.currentTarget).data('on'), 1))
            .on('change', '[data-act="pay"]',   (e) => this.billPopSet($(e.currentTarget).data('on'), 2))
            .on('click',  '[data-act="pick"]',  () => this.getOthereCoinfo())
            .on('click',  '[data-act="ddClose"]', () => this.$el.find('#contractListSelATop').hide())
            .on('click',  '[data-act="reset"]', () => this.resetBizSearch())
            .on('keyup',  '[data-act="search"]', (e) => this.checkBizTitle(e.currentTarget))
            .on('click',  '[data-act="coPick"]', (e) => this.getMyDocInfoSet($(e.currentTarget).data('idx')))
            .on('click',  '[data-act="apply"]',  () => this.saveTaxPopInfo())
            .on('click',  '[data-act="cancel"]', () => $j.Ui.BS.close());
    }

    load() {
        const d = this.data;
        $.ajax({
            type: 'GET',
            url: '/m/ajax/tax-bill/form',
            data: { getmode: d.mode, ordernum: d.ordernum, work_year: d.workYear, work_minth: d.workMonth },
            dataType: 'json',
        }).done((j) => {
            if (!j || j.error) { Util.swalert((j && j.error) || '정보를 불러오지 못했습니다.'); $j.Ui.BS.close(); return; }
            this.$el.html(this.render(j));
            $j.Common.Form.registerNumberHandler('taxin_printprice');
            $j.Common.Form.registerNumberHandler('cont_input_amt');
            this.fillDefaults();
            this.bindDatePickers();
        });
    }

    /** 금액·일자 기본값 — 비어 있으면 장비대금+부가세 / 오늘로 채운다. */
    fillDefaults() {
        const priceTax = parseInt(this.data.carPrice + parseInt(this.data.carPrice * 0.1, 10), 10);
        const today = dayjs().format('YYYY-MM-DD');

        ['cont_input_amt', 'taxin_printprice'].forEach((id) => {
            const el = document.getElementById(id);
            if (el && !(parseInt(el.value, 10) > 0)) el.value = Util.formatNumber(priceTax);
        });
        ['cont_input_date', 'taxin_printdate'].forEach((id) => {
            const el = document.getElementById(id);
            if (el && el.value.length < 10) el.value = today;
        });
        document.getElementById('refordernumval').value = this.data.ordernum;
    }

    // 세금계산서/거래처입금 입력폼 렌더 (JSON → HTML). 구 _sky_m_05_001_scr_get_html.php taxform_of_ball_to_contract 대체.
    //
    // ⚠ 구 마크업은 8열 <table> + colspan 조합에 table-layout:fixed 를 얹은 형태였다.
    //   폭은 첫 행 7칸의 px 값으로만 정해지는데 아래 행들은 colspan 이 달라, 라벨이 세로로 접히고
    //   행마다 우측 끝이 어긋났다(큰글씨에서 가용 폭이 줄자 그대로 드러남).
    //   → 표를 버리고 '라벨 + 필드' 2열 그리드(.taxbill)로 재작성. 한 줄에 한 항목이라 배율과 무관하다.
    //
    // 서버(BizFormService::getTaxForm)는 아직 표현값(radioc01_on / 'table-row')을 내려준다 — API 는 그대로 두고
    // 여기서 불리언으로만 해석한다.
    /**
     * 물음표 도움말 버튼 ($j.Ui.Tooltip 선언형 — data-tip-html 만 달면 위임으로 뜬다)
     * ⚠ 속성값이라 내용에 큰따옴표를 쓰지 않는다.
     */
    _help(title, html) {
        return '<button type="button" class="dsheet__help" aria-label="도움말"'
            + ' data-tip-title="' + title + '" data-tip-html="' + html + '">'
            + '<i class="fas fa-question-circle"></i></button>';
    }

    /** 세그먼트 토글 한 칸 (라디오는 그대로 두고 시각만 칩으로 — .dseg 참고) */
    _opt(name, id, label, checked, on, mtype) {
        return '<label class="dseg__opt"><input type="radio" name="' + name + '" id="' + id + '"'
            + (checked ? ' checked' : '')
            + ' data-act="' + (mtype === 1 ? 'issue' : 'pay') + '" data-on="' + on + '">'
            + '<span>' + label + '</span></label>';
    }

    render(j) {
        // 도움말 본문. 이 화면은 국세청에 계산서를 '발행'하지 않는다 — 발행/수금 사실을 오더에
        // 기록할 뿐이다(BizFormService::saveBizForm → _car_order_tax_info + g5_orders 플래그).
        const HELP_TAX = '계산서를 실제로 발행하는 기능이 아니라, <b>발행했다는 사실을 이 오더에 기록</b>하는 곳입니다.'
            + '<br><br>발행을 고르면 거래처 정보와 발행일·금액이 함께 저장됩니다.'
            + '<br><br>새로 입력한 상호는 거래처 목록에 저장돼, 다음부터 상호칸의 <b>∨</b> 버튼으로 골라 쓸 수 있습니다.';
        const HELP_PAY = '이 오더의 대금을 <b>실제로 받은 내역</b>을 기록합니다.'
            + '<br><br>입금됨을 고르면 수금액·수금처·수금일과 받은 방식(현금/입금)이 저장됩니다.';

        var billOn = (j.tabA === 'table-row');   // 계산서 발행함
        var payOn  = (j.tabB === 'table-row');   // 거래처 입금됨

        function row(label, field, extraCls, id){
            return '<div class="dsheet__row' + (extraCls ? ' ' + extraCls : '') + '"' + (id ? ' id="' + id + '"' : '') + '>'
                + '<span class="dsheet__lb">' + label + '</span>'
                + '<span class="dsheet__fd">' + field + '</span>'
                + '</div>';
        }

        // 상호 콤보 — 등록된 사업자 목록 드롭다운(#contractListSelATop)을 필드 안에 둔다.
        // 구현은 화면좌표(getBoundingClientRect)로 450px 고정폭 패널을 띄웠는데, 그 좌표는 렌더 px 이고
        // style.left 는 레이아웃 px 이라 큰글씨에서 어긋났고 450px 자체가 화면 밖으로 나갔다.
        var conameField = ''
            + '<input type="text" placeHolder="상호입력" id="taxin_coname" value="' + Util.escapeHtml(j.co_title) + '">'
            + '<button type="button" class="taxbill__pick" data-act="pick" aria-label="등록 사업자 선택"><i class="fas fa-chevron-down"></i></button>'
            + '<div class="taxbill__dd" id="contractListSelATop">'
            +   '<div class="taxbill__dd-ser" id="contractListSelASer" style="display:none">'
            +     '<input type="text" placeHolder="사업자 제목 검색" data-act="search">'
            +     '<button type="button" id="conoresetBtn" data-act="reset">초기화</button>'
            +   '</div>'
            +   '<div class="taxbill__dd-list" id="contractListSelA"></div>'
            +   '<div class="taxbill__dd-close" data-act="ddClose">닫기</div>'
            + '</div>';

        return `
    <div class="taxbill">
        <div class="taxbill__sec">
            <div class="dsheet__head">
                <span class="dsheet__head-tit">세금계산서
                    ${this._help('세금계산서', HELP_TAX)}
                </span>
                <span class="dseg">
                    ${this._opt('taxbill_issue', 'popRadio_billSet_no', '미발행', !billOn, 0, 1)}
                    ${this._opt('taxbill_issue', 'popRadio_billSet_on', '발행',   billOn, 1, 1)}
                </span>
            </div>
            <div class="taxbill__body" id="popTaxInBody" style="display:${billOn ? 'block' : 'none'}">
                ${row('상호<br>(법인명)', conameField, 'taxbill__row--combo')}
                ${row('등록번호', '<input type="text" placeHolder="사업자번호" id="taxin_connum" value="' + Util.escapeHtml(j.co_number) + '">')}
                ${row('성명', '<input type="text" placeHolder="대표이름" id="taxin_ceoname" value="' + Util.escapeHtml(j.co_ceoname) + '">')}
                ${row('사업장<br>주소', '<input type="text" placeHolder="사업장 주소" id="taxin_coaddress" value="' + Util.escapeHtml(j.co_address) + '">')}
                ${row('발행일', '<input type="text" placeHolder="발행일" id="taxin_printdate" readonly value="' + Util.escapeHtml(j.billPrintDate) + '">')}
                ${row('금액', '<input type="tel" placeHolder="금액" id="taxin_printprice" data-amount-kor value="' + Util.escapeHtml(j.billPrice) + '">')}
            </div>
        </div>

        <div class="taxbill__sec">
            <div class="dsheet__head">
                <span class="dsheet__head-tit">거래처 입금
                    ${this._help('거래처 입금', HELP_PAY)}
                </span>
                <span class="dseg">
                    ${this._opt('taxbill_pay', 'popRadio_continput_no', '미입금', !payOn, 0, 2)}
                    ${this._opt('taxbill_pay', 'popRadio_continput_on', '입금됨',  payOn, 1, 2)}
                </span>
            </div>
            <div class="taxbill__body" id="popTaxInBody2" style="display:${payOn ? 'block' : 'none'}">
                ${row('수금액', '<input type="tel" id="cont_input_amt" data-amount-kor amd="' + Util.escapeHtml(j.sooGotPayedPrice) + '" value="' + Util.escapeHtml(j.contAmt) + '">')}
                ${row('수금처', '<input type="text" id="cont_input_name" placeHolder="수금해준곳" value="' + Util.escapeHtml(j.contName) + '">')}
                ${row('수금일', '<input type="text" id="cont_input_date" readonly value="' + Util.escapeHtml(j.contDate) + '">')}
                ${row('방식',
                      '<span class="dseg">'
                    + '<label class="dseg__opt"><input type="radio" name="inputcontway" value="현금" id="inputcontway1" ' + j.inTypeA + '><span>현금</span></label>'
                    + '<label class="dseg__opt"><input type="radio" name="inputcontway" value="입금" id="inputcontway2" ' + j.inTypeB + '><span>입금</span></label>'
                    + '</span>',
                      'taxbill__row--radios')}
            </div>
        </div>

        <div class="dsheet__note">PC에서 사용시 좀더 세부항목 입력가능 합니다.</div>
        <div class="dsheet__foot">
            <button type="button" class="dsheet__btn dsheet__btn--ok" data-act="apply">적용</button>
            <button type="button" class="dsheet__btn" data-act="cancel">취소</button>
        </div>

        <input type="hidden" id="refordernumval" value="0">
        <input type="hidden" id="contcoref_no" value="${j.contcorefNo}">
        <input type="hidden" id="contcoref_conum" value="${j.contcorefConum}">
        <input type="hidden" id="contcoref_work_year" value="${j.workYear}">
        <input type="hidden" id="contcoref_work_minth" value="${j.workMonth}">
        <input type="hidden" id="popTaxinmode" value="${j.getmode}">
    </div>
    `;
    }

    /**
     * 발행/미발행 · 입금됨/미입금 라디오 토글 → 해당 입력영역 노출
     *
     * 구현은 <img src=radioc01[_on].png> 의 src 를 갈아끼우고, 저장 시 그 src 문자열을 검사해
     * 선택 여부를 판정했다(브라우저 라디오가 아니라 접근성·키보드·다크 대응이 전무). 진짜
     * <input type="radio"> 로 바꾸고 판정도 .checked 로 한다.
     *
     * @param act   1=발행/입금됨, 0=미발행/미입금
     * @param mtype 1=세금계산서, 2=거래처입금
     */
    billPopSet(act, mtype) {
        const on = (parseInt(act, 10) === 1);
        const ids = (parseInt(mtype, 10) === 2)
            ? { on: 'popRadio_continput_on', no: 'popRadio_continput_no', body: 'popTaxInBody2' }
            : { on: 'popRadio_billSet_on',   no: 'popRadio_billSet_no',   body: 'popTaxInBody' };

        const $on = $('#' + ids.on), $no = $('#' + ids.no);
        if (!$on.length) return;
        $on.prop('checked', on);
        $no.prop('checked', !on);
        $('#' + ids.body).toggle(on);
    }

    /**
     * 발행일 / 수금일 — 모비스크롤 달력
     *
     * 구현은 클릭하면 년/월/일 <select> 3개를 표 안에 펼쳐 넣었다(행이 늘었다 줄었다 하며
     * 레이아웃이 흔들리고, 큰글씨에서는 3개가 한 줄에 들어가지 않았다).
     * 테마(다크/라이트)는 F/Mobile/Theme 의 syncMobiscroll 이 전역으로 맞춘다.
     */
    bindDatePickers() {
        if (typeof mobiscroll === 'undefined') return;
        ['taxin_printdate', 'cont_input_date'].forEach((id) => {
            const $el = $('#' + id);
            if (!$el.length) return;
            $el.mobiscroll('destroy');
            $el.mobiscroll().datepicker({
                controls: ['calendar'],
                display: 'center',
                locale: mobiscroll.localeKo,
                dateFormat: 'YYYY-MM-DD',
                defaultSelection: $el.val() || undefined,
            });
        });
    }

    getContInfos() {
        console.log("getContInfos");
    }

    make_DocList(data, stype) {
        var ret = "<div style='width:100%; height:5px'></div>";
        var func = stype == "SELF" ? 1 : 2;
        for (var i = 0; i < data.length; i++) {
            var chit = data[i];
            ret += "<div class='contserpopcp' id='bizformea' s_key='" + Util.escapeHtml(chit.s_key) + "' s_tit='" + Util.escapeHtml(chit.co_title) + "'>";
            ret += "<div class='contserpopcpin' data-act='coPick' data-idx='" + i + "'>" + Util.escapeHtml(chit.co_number) + "</div>";
            ret += "<div class='contserpopcpin' data-act='coPick' data-idx='" + i + "'>" + Util.escapeHtml(chit.co_title) + "</div>";
            ret += "</div>";
        }
        ret += "<div style='width:100%; height:5px'></div>";
        return ret;
    }

    getOthereCoinfo() {
        this.coBoxCalTar = null;
        if (this.otherCoDocs == null) {
            this.coBoxCalTar = true;
            this.get_Other_DocList("");
            return;
        }
        // 목록은 상호 필드 안(.taxbill__row--combo)에 붙어 있는 패널이다 — CSS 가 left:0/right:0 로
        // 필드 폭에 맞춘다. 구현은 화면좌표(getBoundingClientRect, 렌더 px)를 style.left(레이아웃 px)에
        // 넣고 폭을 450px 로 못박아, 큰글씨에서 위치가 밀리고 우측이 화면 밖으로 잘렸다.
        var objTop = document.getElementById("contractListSelATop");
        var obj = document.getElementById("contractListSelA");
        $('#Contract_DocTop').hide();
        if (objTop.style.display == "block" && window.ontractListOpenTab == 3) { objTop.style.display = "none"; return; }
        var ret;
        if (this.otherCoDocs.length > 0) {
            if (this.otherCoDocs.length > 7) document.getElementById("contractListSelASer").style.display = "block";
            ret = this.make_DocList(this.otherCoDocs, "OTHER");
        } else {
            ret = "<div class='taxbill__dd-empty'>등록된 사업자가 없습니다.</div>";
        }
        obj.innerHTML = ret;
        objTop.style.display = "block";
        window.ontractListOpenTab = 3;
        window.coBizSelMode = "OTHER";
    }

    get_Other_DocList(co_title) {
        const self = this;
        var sendData = { "getdoctype": "OTHER", "user_no": window.LoginNo, "co_title": co_title };
        $.ajax({
            type: "GET", url: "/m/ajax/tax-bill/co-docs", data: sendData, dataType: "json", success: function (data) {
                var myData = data.datas;
                if (typeof (myData) != "object") myData = [];
                self.otherCoDocs = myData;
                if (self.coBoxCalTar) self.getOthereCoinfo();
            }
        });
    }

    // 사업자 검색 초기화 — 구 마크업의 onclick="coinfosetClear(2)" 는 모바일에 정의가 없어 죽은 호출이었다.
    resetBizSearch() {
        const $ser = $('#contractListSelASer input');
        $ser.val('');
        $('#contractListSelA > div').show();
        $ser.trigger('focus');
    }

    checkBizTitle(tar) {
        var obj = document.getElementById("contractListSelA");
        var inputs = obj.getElementsByTagName("div");
        var serKey = tar.value.trim();
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].id == "bizformea") {
                var skey = inputs[i].getAttribute("s_key");
                var stit = inputs[i].getAttribute("s_tit");
                if (serKey == "" || (skey == serKey || stit.indexOf(serKey) >= 0)) {
                    inputs[i].style.display = "block";
                } else {
                    inputs[i].style.display = "none";
                }
            }
        }
    }

    getMyDocInfoSet(refno, Stype) {
        console.log("refno:" + refno + " / type:" + Stype);
        if (refno == undefined) refno = 0;
        refno = parseInt(refno);
        if (isNaN(refno)) refno = 0;
        var regeditcoInfo_cono = "";
        var regeditcoInfo_address = "";
        var regeditcoInfo_cotitle = "";
        var regeditcoInfo_ceoname = "";
        var regeditcoInfo_cotel = "";
        var regeditcoInfo_coperson = "";
        var regeditcoInfo_cofax = "";
        var regeditcoInfo_persontel = "";
        var thisstampurl = "";
        $('#contractListSelATop').hide();
        if (refno >= 0) {
            var chit = this.otherCoDocs[refno];
            console.log(chit);
            if (typeof (chit) != "object") chit = {};
            regeditcoInfo_cono = chit.co_number;
            regeditcoInfo_address = chit.co_address;
            regeditcoInfo_cotitle = chit.co_title;
            regeditcoInfo_ceoname = chit.co_ceoname;
            regeditcoInfo_cotel = chit.co_tel;
            regeditcoInfo_coperson = chit.co_manager;
            regeditcoInfo_cofax = chit.co_fax;
            regeditcoInfo_persontel = chit.co_managertel;
            thisstampurl = chit.stamp_url;


            document.getElementById("contcoref_no").value = chit.rsno;
            document.getElementById("contcoref_conum").value = regeditcoInfo_cono;

            document.getElementById("taxin_connum").value = regeditcoInfo_cono;
            document.getElementById("taxin_coname").value = regeditcoInfo_cotitle;
            document.getElementById("taxin_ceoname").value = regeditcoInfo_ceoname;
            document.getElementById("taxin_coaddress").value = regeditcoInfo_address;
            if (document.getElementById("cont_input_name").value == "") {
                document.getElementById("cont_input_name").value = regeditcoInfo_cotitle;
            }
        }
    }

    saveTaxPopInfo() {
        var sendData = {};
        var refordernumval = document.getElementById("refordernumval").value;
        refordernumval = parseInt(refordernumval);
        if (isNaN(refordernumval)) refordernumval = 0;
        if (refordernumval < 10) { Util.swalert("잘못된 오더번호 입니다."); return; }
        sendData["regeditcoInfo_cono"] = 0;
        sendData["bal_print_taxbill_to_bal"] = 0;
        sendData["jobtype"] = "save_edit_co_bizformdo";
        sendData["ordernum"] = refordernumval;
        sendData["popTaxinmode"] = document.getElementById("popTaxinmode").value;
        var editno = document.getElementById("contcoref_no").value;
        var orgnno = document.getElementById("contcoref_conum").value;
        editno = parseInt(editno);
        if (isNaN(editno)) editno = 0;
        if (editno > 0) {
            var taxin_connum = document.getElementById("taxin_connum").value;
            var contcoref_conum = document.getElementById("contcoref_conum").value;
            if (taxin_connum != contcoref_conum) editno = 0;
        }
        // 진짜 라디오의 .checked 로 판정한다 (구현은 <img> 의 src 문자열에 '_on.png' 가 있는지 봤다).
        var ch1 = document.getElementById("popRadio_billSet_on").checked;
        var ch2 = document.getElementById("popRadio_continput_on").checked;

        var contcoref_work_year = parseInt(document.getElementById("contcoref_work_year").value);
        var contcoref_work_minth = parseInt(document.getElementById("contcoref_work_minth").value);
        if (isNaN(contcoref_work_year)) contcoref_work_year = 0;
        if (isNaN(contcoref_work_minth)) contcoref_work_minth = 0;
        if (contcoref_work_year < 1900 || contcoref_work_minth < 1 || contcoref_work_minth > 12) { Util.swalert("오더의 년, 월 에러 입니다."); return; }
        sendData["contcoref_work_year"] = contcoref_work_year;
        sendData["contcoref_work_minth"] = contcoref_work_minth;

        var pp;
        if (ch1) {
            if (document.getElementById("taxin_connum").value.length < 10 || document.getElementById("taxin_coname").value.length < 2) {
                Util.swalert("회사 사업자 번호와 상호를 입력해 주세요");
                return;
            }
            pp = document.getElementById("taxin_printprice").value.replaceAll(",", "");
            pp = parseInt(pp);
            if (isNaN(pp)) pp = 0;
            if (pp == 0) { Util.swalert("계산서 발행 액을 입력해 주세요"); return; }
            sendData["regeditcoInfo_cono"] = editno;
            sendData["bal_print_taxbill_to_bal"] = 1;
            sendData["co_number"] = document.getElementById("taxin_connum").value;
            sendData["co_address"] = document.getElementById("taxin_coaddress").value;
            sendData["co_title"] = document.getElementById("taxin_coname").value;
            sendData["co_ceoname"] = document.getElementById("taxin_ceoname").value;
            sendData["co_tel"] = "";
            sendData["co_manager"] = "";
            sendData["co_fax"] = "";
            sendData["co_managertel"] = "";
            sendData["bal_print_taxbill_to_bal_date"] = document.getElementById("taxin_printdate").value;;
            sendData["bal_print_taxbill_price"] = pp;
        }

        if (ch2) {
            if (document.getElementById("cont_input_date").value.length < 10 || document.getElementById("cont_input_amt").value.length < 3) {
                Util.swalert("입금액과 입금 날짜를 입력해 주세요");
                return;
            }
            var bal_got_payed_by = "입금";
            if (document.getElementById("inputcontway1").checked == true) bal_got_payed_by = "현금";
            pp = document.getElementById("cont_input_amt").value.replaceAll(",", "");
            pp = parseInt(pp);
            if (isNaN(pp)) pp = 0;
            if (pp == 0) { Util.swalert("입금액을 입력해 주세요"); return; }
            sendData["bal_got_payed"] = 1;
            sendData["bal_got_payed_price"] = pp;
            sendData["bal_got_payed_sender"] = document.getElementById("cont_input_name").value;
            sendData["bal_got_payed_date"] = document.getElementById("cont_input_date").value;
            sendData["bal_got_payed_by"] = bal_got_payed_by;
        }

        $.ajax({
            type: "POST", url: "/m/ajax/tax-bill/save", data: sendData, dataType: "json", success: function (data) {
                var hdd = "거래처";
                if (sendData["popTaxinmode"] == "soo_bill_issued") hdd = "계산서";
                var htm = "";
                if (sendData["bal_print_taxbill_to_bal"] == 1) {
                    htm += "<span class='dia-rdo is-on' style='position:relative;vertical-align:top;top:5px'></span>"
                    htm += "<div style='display:inline-block;position:relative;vertical-align:top;line-height:30px;top:5px'>" + hdd + " <font style='color:var(--diary-sat)'>발행</font></div> &nbsp;</div>";
                } else {
                    htm += "<span class='dia-rdo' style='position:relative;vertical-align:top;top:5px'></span>";
                    htm += "<div style='display:inline-block;position:relative;vertical-align:top;line-height:30px;top:5px'>" + hdd + " <font style='color:var(--diary-sun)'>미발행</font></div> &nbsp;</div>";
                }
                if (window.billsetDiv) window.billsetDiv.innerHTML = htm;
                $j.Ui.BS.close();
            }
        });
    }
}
